
import React, { useState, useEffect } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import InvestmentPolicy from '@/components/alm/investments/InvestmentPolicy';
import InvestmentOperations from '@/components/alm/investments/InvestmentOperations';
import InvestmentInventory from '@/components/alm/investments/InvestmentInventory';
import { useInvestmentPageState } from '@/components/alm/investments/hooks/useInvestmentPageState';
import { Skeleton } from "@/components/ui/skeleton";
import LazyLoad from "@/components/LazyLoad";

const TabContentSkeleton = () => (
  <div className="w-full animate-pulse">
    <Skeleton className="h-8 w-1/2 mb-4" />
    <Skeleton className="h-64 w-full mb-4" />
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <Skeleton className="h-32" />
      <Skeleton className="h-32" />
    </div>
  </div>
);

const InvestmentsPage = () => {
  const { activeTab, setActiveTab, amountFromUrl, horizonFromUrl } = useInvestmentPageState();
  const [isLoading, setIsLoading] = useState(true);

  // Simulate faster initial load with shorter timeout
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 50);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="flex flex-col gap-6">
      <div>
        <h1 className="text-3xl font-bold tracking-tight">Investments Management</h1>
        <p className="text-muted-foreground">
          Manage surplus liquidity through investments in Fixed Deposits and Liquid Mutual Funds
        </p>
      </div>

      {isLoading ? (
        <div className="w-full animate-pulse">
          <Skeleton className="h-10 w-full max-w-md mb-4" />
          <Skeleton className="h-64 w-full mb-4" />
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <Skeleton className="h-32" />
            <Skeleton className="h-32" />
            <Skeleton className="h-32" />
          </div>
        </div>
      ) : (
        <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
          <TabsList>
            <TabsTrigger value="portfolio">Portfolio</TabsTrigger>
            <TabsTrigger value="policy">Investment Policy</TabsTrigger>
            <TabsTrigger value="operations">Investment Operations</TabsTrigger>
          </TabsList>
          <TabsContent value="portfolio" className="space-y-4 py-4">
            <LazyLoad delay={100}>
              <InvestmentInventory />
            </LazyLoad>
          </TabsContent>
          <TabsContent value="policy" className="space-y-4 py-4">
            <LazyLoad delay={150}>
              <InvestmentPolicy />
            </LazyLoad>
          </TabsContent>
          <TabsContent value="operations" className="space-y-4 py-4">
            <LazyLoad delay={200}>
              <InvestmentOperations 
                initialAmount={amountFromUrl ? parseFloat(amountFromUrl) : undefined}
                timeHorizon={horizonFromUrl || undefined}
              />
            </LazyLoad>
          </TabsContent>
        </Tabs>
      )}
    </div>
  );
};

export default InvestmentsPage;
